import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Cookies from 'js-cookie';
import { event as fbqEvent } from '../src/js/lib/fbq';
import { event as ttqEvent } from '../src/js/lib/ttq';
import { event as plausibleEvent } from '../src/js/lib/plausible';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('turbo:load', function () {
  console.log('global.js loaded');

  if (Cookies.get('signed_up')) {
    console.log('fbq event: User signed up');

    Cookies.remove('signed_up');

    fbqEvent('track', 'CompleteRegistration');
    ttqEvent('CompleteRegistration');

    plausibleEvent('Signup');
  }

  if (Cookies.get('service_connected')) {
    console.log('plausible event: Service connected');

    plausibleEvent('Device connected', {
      service: Cookies.get('service_connected'),
    });
    Cookies.remove('service_connected');
  }

  $('body').on('click', function (e) {
    // open/close main menu
    handleMainMenu(e);
    handleLocalMenus(e);
  });

  $('.read-more').on('click', function () {
    if (!$(this).hasClass('open')) {
      $('.read-more-truncated').addClass('hidden');
      $('.read-more-content').removeClass('hidden');
      $(this).addClass('open');
      $(this).html('Read less');
    } else {
      $('.read-more-truncated').removeClass('hidden');
      $('.read-more-content').addClass('hidden');
      $(this).removeClass('open');
      $(this).html('Read more');
    }
  });

  $('.close-notification').on('click', function () {
    // close notification
    console.log('close notification:', $(this).data('notification'));
    if (
      $(this).data('notification') !== 'alert' &&
      $(this).data('notification') &&
      'notice'
    ) {
      // Set cookie to hide notification for ever.
      Cookies.set('notification_' + $(this).data('notification'), 'hidden', {
        expires: 365,
      });
    }

    $(this).parent().remove();
  });

  function handleMainMenu(e) {
    const targetElement = document.querySelector('#side-navigation-content');

    if ($(e.target).hasClass('toggle-menu')) {
      // clicked on toggle-menu button.
      if ($('#main-menu').hasClass('closed') && window.innerWidth >= 768) {
        // menu is closed. Open it
        $('#main-menu').removeClass('closed');
        $('#menu-icons-container').addClass('hidden');
      } else {
        // menu is open. Close it.
        $('#main-menu').addClass('closed');
        $('#menu-icons-container').removeClass('hidden');
      }

      if ($('#side-navigation').hasClass('hidden') && window.innerWidth < 768) {
        // side-navigation is closed. Open it
        $('#side-navigation').removeClass('hidden');
        $('#side-navigation').addClass('flex');
        $('#side-menu-background').removeClass('hidden');
        $('#side-menu-background').addClass('block');
        disableBodyScroll(targetElement);
      } else {
        // side-navigation is open. Close it.
        $('#side-navigation').removeClass('flex');
        $('#side-navigation').addClass('hidden');
        $('#side-menu-background').removeClass('block');
        $('#side-menu-background').addClass('hidden');
        enableBodyScroll(targetElement);
      }
    } else {
      // clicked outside toggle-menu button
      if (!$('#main-menu').hasClass('closed') && window.innerWidth >= 768) {
        // menu is open
        if ($(e.target).closest('#main-menu').length === 0) {
          // clicked outside of menu. Close it
          $('#main-menu').addClass('closed');
          $('#menu-icons-container').removeClass('hidden');
        }
      }

      if (
        !$('#side-navigation').hasClass('hidden') &&
        window.innerWidth < 768
      ) {
        // menu is open
        if ($(e.target).closest('#side-navigation').length === 0) {
          // clicked outside of menu. Close it
          $('#side-navigation').addClass('hidden');
          $('#side-menu-background').addClass('hidden');
          enableBodyScroll(targetElement);
        }
      }
    }
  }

  function handleLocalMenus(e) {
    if ($(e.target).hasClass('open-local-menu')) {
      // clicked on toggle-menu button.

      var menu = $(e.target)
        .closest('.local-menu-container')
        .find('.local-menu');
      if (menu) {
        // menu for button exists
        if (menu.hasClass('open')) {
          // local menu for clicked trigger is open. Close current menu
          menu.removeClass('open');
          menu.addClass('hidden');
        } else {
          // close all local menus, before opening proper one.
          $('.local-menu.open').removeClass('open');
          $('.local-menu').addClass('hidden');

          menu.addClass('open');
          menu.removeClass('hidden');
        }
      }
    } else {
      // clicked outside toggle-menu button
      if ($('.local-menu.open').length > 0) {
        // some local menu is open
        if ($(e.target).closest('.local-menu-container').length === 0) {
          // clicked outside of menu. Close'em

          $('.local-menu.open').removeClass('open');
          $('.local-menu').addClass('hidden');
        }
      }
    }
  }

  const topMenuBar = document.querySelector('#topMenuBar');

  ScrollTrigger.create({
    trigger: topMenuBar,
    start: 'top top',
    end: 99999,
    toggleClass: { className: 'top-menu-bar-scrolled', targets: topMenuBar },
  });
});
